import { render, staticRenderFns } from "./make-food.vue?vue&type=template&id=2b5c4106&scoped=true&"
import script from "./make-food.vue?vue&type=script&lang=js&"
export * from "./make-food.vue?vue&type=script&lang=js&"
import style0 from "./make-food.vue?vue&type=style&index=0&id=2b5c4106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c4106",
  null
  
)

export default component.exports